/** @format */

import React, { useCallback } from "react";
import { InputText } from "primereact/inputtext";
import service from "../../utils/service";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputTextarea } from "primereact/inputtextarea";
import "../../style/channel.css";
import { Toast } from "primereact/toast";
import moment from "moment";
import AccordionLoader from "../common/AccordionLoader";
import useGetRegions from "../../hooks/useRegions";
import { filterDataOnRoles, getRowsPerPage } from "./utils/utils";
import SubscriptionTable from "./common/SubscriptionTable";

function Subscription(props) {
  const [ShowApprovedDialog, setApprovedDialog] = React.useState(false);
  const [showDenyDialog, setDenyDialog] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [subscriptionData, setSubscriptionData] = React.useState([]);
  const [requestData, setRequestData] = React.useState({});
  const [reason, setReason] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [approveDenyLoading, setApproveDenyLoading] = React.useState(false);
  const { isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isSuperAdminRole, isGrainsRole, isCornRole } = props;
  const ROWS_PER_PAGE_CONST = 10;
  const regionsData = useGetRegions();
  const getSubscriptions = useCallback(() => {
    return service.getPendingSubscriptions().then((response) => {
      let data = isSuperAdminRole
        ? response.data
        : filterDataOnRoles(response.data, isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isGrainsRole, isCornRole);
      setSubscriptionData(data);
    });
  }, [isSuperAdminRole, isEdibleOilsRole, isCocoaRole, isAnimalFeedRole, isGrainsRole, isCornRole]);

  React.useEffect(() => {
    setSubscriptionData([]);
    setLoading(true);
    getSubscriptions()
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [getSubscriptions]);

  const searchSubscription = (str) => {
    str = str.toLowerCase();
    return subscriptionData.filter((data) => data.user.toLowerCase().includes(str));
  };

  const setSubscriptionStatus = (event) => {
    var value = event.target.value;
    if (value === "Approve") {
      setApprovedDialog(true);
      event.target.value = "select";
    } else if (value === "Deny") {
      setDenyDialog(true);
      event.target.value = "select";
    }
  };

  let dialogHeder = "";
  if (ShowApprovedDialog) {
    dialogHeder = "Approve";
  } else {
    dialogHeder = "Deny";
  }
  const columns = [
    {
      field: "requestedDate",
      header: "Requested Date",
      body: (data) => moment(data.requestedDate).format("MMM Do YYYY"),
    },
    { field: "user", header: "User" },
    { field: "email", header: "Email" },
    { field: "channel", header: "Channel" },
    { field: "region", header: "Region" },
    {
      field: "status",
      header: "Status",
      body: (data) => {
        if (data.status === "Approved") {
          return <div style={{ color: "#638C1C" }}> {data.status} </div>;
        }
        if (data.status === "Denied") {
          return <div style={{ color: "#A22B2F" }}> {data.status} </div>;
        }
        if (data.status === "Pending") {
          return (
            <select
              defaultValue='select'
              onChange={(event) => {
                setRequestData(data);
                setSubscriptionStatus(event);
              }}
            >
              <option disabled value='select'>
                select
              </option>
              <option value='Approve'>Approve</option>
              <option value='Deny'>Deny</option>
            </select>
          );
        }
      },
    },
  ];
  var subsData = searchSubscription(searchText);
  const toast = React.useRef(null);
  return (
    <div style={{ marginTop: "1rem" }}>
      <Toast ref={toast} baseZIndex={20000} />
      <div style={{ marginTop: "1rem", color: "#cccccc" }}>
        <div className='p-fluid formgrid grid'>
          <div className='field col-12 md:col-2'>
            <label htmlFor='searchUser'>Search user</label>
            <InputText
              id='searchUser'
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
              type='text'
            />
          </div>
        </div>
        {(loading || regionsData.isLoading) && <AccordionLoader />}
        <div style={{ position: "relative" }}>
          {!loading && (
            <SubscriptionTable
              data={subsData}
              rows={ROWS_PER_PAGE_CONST}
              rowsPerPageOptions={getRowsPerPage(subsData, ROWS_PER_PAGE_CONST)}
              columns={columns}
            />
          )}
          {approveDenyLoading && (
            <div
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundColor: "#000",
                opacity: "0.65",
                zIndex: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <ProgressSpinner />
            </div>
          )}
        </div>
        <Dialog
          baseZIndex={10001}
          className='diag1 subscriptionDialog'
          header={dialogHeder}
          visible={ShowApprovedDialog || showDenyDialog}
          style={{ width: "500px" }}
          onHide={() => {
            setReason("");
            ShowApprovedDialog ? setApprovedDialog(false) : setDenyDialog(false);
          }}
          focusOnShow={false}
        >
          <form
            id='dialogForm'
            onSubmit={(event) => {
              event.preventDefault();
              let json = {};
              json.regionRequestId = requestData.regionRequestId;
              json.userId = requestData.userId;
              // json.email = requestData.email;
              let selectedRegion =
                regionsData.data &&
                regionsData.data.find(
                  (region) => region.region.toLocaleLowerCase() === requestData.region.toLocaleLowerCase()
                );
              json.regionId = selectedRegion ? selectedRegion.id : -1;
              json.channelId = requestData.channelId;
              if (ShowApprovedDialog) {
                setApproveDenyLoading(true);
                service
                  .approveSubscription(json)
                  .then((response) => {
                    toast.current.show({
                      severity: "success",
                      summary: "Success",
                      detail: "Subscription request approved successfully",
                      life: 3000,
                    });
                    getSubscriptions()
                      .then(() => {
                        setApproveDenyLoading(false);
                      })
                      .catch((err) => {
                        setApproveDenyLoading(false);
                      });
                  })
                  .catch((error) => {
                    toast.current.show({
                      severity: "error",
                      summary: "Error",
                      detail: "Error while accepting subscription request",
                      life: 3000,
                    });
                    console.error(error);
                    setApproveDenyLoading(false);
                  });
              } else {
                setApproveDenyLoading(true);
                json.regionRejectReason = reason;
                service
                  .denySubscription(json)
                  .then((response) => {
                    toast.current.show({
                      severity: "success",
                      summary: "Success",
                      detail: "Subscirption request denied successfully",
                      life: 3000,
                    });
                    getSubscriptions()
                      .then(() => {
                        setApproveDenyLoading(false);
                      })
                      .catch((err) => {
                        setApproveDenyLoading(false);
                      });
                  })
                  .catch((error) => {
                    toast.current.show({
                      severity: "error",
                      summary: "Error",
                      detail: "Error while denying subscription request",
                      life: 3000,
                    });
                    console.error(error);
                    setApproveDenyLoading(false);
                  });
              }
              setReason("");
              ShowApprovedDialog ? setApprovedDialog(false) : setDenyDialog(false);
            }}
          >
            <div className='diag-box'>
              <div className='grid'>
                <div className='col-6 p-0 p-text-left diag-header'>Channel</div>
                <div className='col-6 p-0 p-text-left diag-header'>Region</div>
                <div className='col-6 pl-0 p-text-left diag-row'>{requestData.channel}</div>
                <div className='col-6 pl-0 p-text-left diag-row'>{requestData.region}</div>
                <div className='col-12 p-0 diag-message'>
                  {ShowApprovedDialog
                    ? "Are you sure you want to approve the request?"
                    : "Are you sure you want to deny the request?"}
                </div>
                {showDenyDialog && (
                  <div className='col-12 pr-6 pl-0'>
                    <div className='col-12 p-0 diag-reason text-center'>Reason for Denial</div>
                    <div className='col-12'>
                      <InputTextarea
                        required
                        rows={5}
                        cols={30}
                        value={reason}
                        onChange={(event) => {
                          let value = event.target.value;
                          let alphaRegex = /^[a-zA-Z ]*$/;
                          if (!alphaRegex.test(value)) {
                            event.preventDefault();
                            event.stopPropagation();
                          } else {
                            setReason(value);
                          }
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className='col-12' style={{ margin: "0.5rem" }}></div>
                <div className='col-6 p-0'>
                  <Button
                    label={ShowApprovedDialog ? "Approve" : "Send"}
                    type='submit'
                    form='dialogForm'
                    className='p-button p-button-sm diag-save-button'
                  />
                </div>
                <div className='col-6 p-0'>
                  <Button
                    type='button'
                    label='Cancel'
                    className='p-button p-button-sm diag-discard-button'
                    onClick={() => {
                      setReason("");
                      ShowApprovedDialog ? setApprovedDialog(false) : setDenyDialog(false);
                    }}
                  />
                </div>
              </div>
            </div>
          </form>
        </Dialog>
      </div>
    </div>
  );
}

export default Subscription;
